import _refiner from 'refiner-js';

const isStaging = window.location.hostname.includes('staging') || window.location.hostname.includes('local');
const REFINER_PROJECT_ID = isStaging ? '31bbfea0-61aa-11f0-b141-5d47f4b689c0' : '12e8b470-3fba-11f0-b1f1-4fc5315d6bab';

_refiner('setProject', REFINER_PROJECT_ID);

export const identify = user => {
  const { segment_id, email, name } = user;
  _refiner('identifyUser', {
    id: segment_id,
    email,
    name,
  });
};
